/** @jsxImportSource @emotion/react */
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { Divider } from "../../components/Divider";
import { css } from "@emotion/react";
import { useSelector } from "react-redux";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SalesChannelItem } from "./SalesChannelItem";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { Shop } from "./model/ShopSuccessResponse";
import { SalesChannelListItem } from "./models/sales-channel";
import * as authSelectors from "../auth/authSelectors";
import { ButtonExternalLink } from "../../components/NewButtons";
import { PlaceholderButton } from "../../components/PlaceholderButton";
import { heapsGoAdminNewSalesChannelUrl } from "./heapsgo-admin-links";

// Hacking width until all cards on page are updated
export const cardAdditionalStyling = css`
  max-width: 1174px !important;
`;

export const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

// Normally we would use PageWrapper component, but other components on the page are not updated yet
export const cardWrapperStyle = css`
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

type Props = {
  shop: Shop;
  salesChannels: SalesChannelListItem[];
};

export const SalesChannelsList = ({ shop, salesChannels }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const hasSalesChannels = salesChannels && salesChannels.length > 0;
  const newSalesChannelUrl =
    shop.id && heapsGoAdminNewSalesChannelUrl(organizationKeyName, shop.id);

  return (
    <div css={cardWrapperStyle}>
      <CardContainer css={cardAdditionalStyling}>
        <PageHeader title="Sales channels">
          {hasSalesChannels && newSalesChannelUrl && (
            <ButtonExternalLink href={newSalesChannelUrl}>
              Create in the new admin
            </ButtonExternalLink>
          )}
        </PageHeader>
        {hasSalesChannels ? (
          <div css={wrapperStyle}>
            <Divider />
            {salesChannels.map((salesChannel, i) => (
              <SalesChannelItem
                key={salesChannel.id}
                showDivider={i + 1 !== salesChannels.length}
                salesChannel={salesChannel}
                shop={shop}
              />
            ))}
          </div>
        ) : (
          <CardBody css={cardBodyAdditionalStyling}>
            {newSalesChannelUrl && (
              <PlaceholderButton
                type="button"
                icon={
                  <FontAwesomeIcon icon={solid("arrow-right-arrow-left")} />
                }
                header="Create your first sales channel in the new admin"
                subHeader="No sales channels created yet"
                onClick={() =>
                  window.open(
                    newSalesChannelUrl,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              />
            )}
          </CardBody>
        )}
      </CardContainer>
    </div>
  );
};
